const xml2js = require('xml2js')
const parseString = require('xml2js').parseString

export default {
  methods: {
    // methods used to parse xml2json
    getSitemapJson (_this) {
      this.axios.get('/sitemap.xml').then(res => {
        return res.data
      }).then(xmlSitemap => parseString(xmlSitemap, function (err, result) {
        if (!err) {
          _this.sitemapContent = result
          _this.sitemapContentExists = !_this.sitemapContentExists
        } else {
          console.log(err)
        }
      }))
    },
    parseJsonToXml (sitemapXml) {
      let builder = new xml2js.Builder()
      return builder.buildObject(sitemapXml)
    },
    // eslint-disable-next-line camelcase
    addFieldSitemap (oldSitemap, data) {
      oldSitemap.urlset.url.push({
        'lastmod': [data.created_at.split(' ')[0]],
        'loc': [`${window.location.origin}/${data.type === 'news' ? 'new' : 'pags'}/${data.slug}`],
        'priority': ['0.5']
      })
      return oldSitemap
    },
    submitSitemapChanges (sitemapContent) {
      this.axios.post('/upload', sitemapContent, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Accept': 'text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8',
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Allow-Headers': 'X-PINGOTHER, Content-Type',
          'Access-Control-Max-Age': '86400'
        }
      }).then(res => {
        if (res.data !== undefined) {
          this.SET_TOAST({ msg: 'Site map updated successfully' })
        } else {
          this.SET_AVISO('Site map data not updated')
        }
      }).catch(err => {
        console.log('Error: ', err)
        this.SET_AVISO(err.response.data.error)
      })
    },
    // when we delete a page=> delete the sitemap field
    removeFieldSitemap (slug) {
      const _slug = slug
      this.axios.get('/sitemap.xml').then(res => {
        return res.data
      }).then(xmlMapRem => {
        let finalJson = {}
        parseString(xmlMapRem, function (err, result) {
          if (!err) {
            let index = null
            result.urlset.url.map((x, i) => {
              if (x.loc[0].includes(_slug)) {
                index = i
              }
            })
            if (index !== null) {
              result.urlset.url.splice(index, 1)
              finalJson = result
            }
          } else {
            console.log(err)
          }
        })
        return finalJson
      }).then(sitemapDel => {
        let builder = new xml2js.Builder()
        return builder.buildObject(sitemapDel)
      }).then(sitemapXml => {
        this.axios.post('/upload', sitemapXml, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Accept': 'text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers': 'X-PINGOTHER, Content-Type',
            'Access-Control-Max-Age': '86400'
          }
        }).then(r => r)
      }).catch(error => console.log(error))
    }
    // end of methods used to parse xml2json
  }
}
